import { Currency } from '../../schemas/product';

const usePrices = (
    currency: Currency | undefined
): {
    displayPrice: (price: number) => string;
    roundPrice: (price: number) => string;
} => {
    const roundPrice = (price: number) => {
        return (Math.round((price + Number.EPSILON) * 100) / 100).toFixed(2);
    };

    const displayPrice = (price: number) => {
        if (currency) {
            return String(
                currency.prefix + roundPrice(Number(price)) + currency.suffix
            );
        } else {
            return String(roundPrice(Number(price)));
        }
    };

    return {
        displayPrice,
        roundPrice,
    };
};

export default usePrices;
